import { liveUsageMgmtAppliedFilterTemplateSelector } from "./liveUsageMgmtAppliedFilterTemplateSelector";
import { RootState } from "../../../store";

export const liveUsageMgmtAppliedFilterTemplateIsSourceCloudchiprSelector = (
  state: RootState,
) => {
  const data = liveUsageMgmtAppliedFilterTemplateSelector(state);
  return data?.source === "cloudchipr";
};
